import * as React from 'react';
import Loader from './Loader';
import { GuideCard } from './GuideCard';
import NewGuideCard from './NewGuideCard';
import { CardList } from './CardList';
import { Guide } from '../guide';
import { ProfileContext, ProfileManager } from '../profile';
import { useRequest, getHeaders } from '../api/client';
import { Card } from './Card';
import PromoCard from './PromoCard';
import { Link } from 'react-router-dom';
import { newGuide } from '../components/NewGuideCard';

const guides = (context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    body: '{}',
    method: 'POST',
    url: '/guides',
    headers: getHeaders(context),
  }));

  return state;
};

const stats = (context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    method: 'GET',
    url: '/stats/guides',
    headers: getHeaders(context),
  }));

  return state;
};

const getStatsForGuide = (state: any, id: any) => {
  return state.find(
    (item: any) => item.guide_id.toLowerCase() === id.toLowerCase(),
  );
};

type Props = {
  children?: React.ReactNode;
};

export default (props: Props) => {
  const context = React.useContext(ProfileContext);
  const state = guides(context);
  const statsState = stats(context);

  if (state.error || statsState.error) {
    return <Card>Error: {state.error.message}</Card>;
  }

  if (!state.data || state.loading || statsState.loading) {
    return <Loader />;
  }

  return (
    <CardList className="animated fadeIn">
      {state.data.length === 0 && (
        <React.Fragment>
          <PromoCard
            image_url="/images/empty_states/guides.png"
            title="Create your first brew guide"
            subtitle="Keep track of your brew recipes and coffee techniques in one place."
          >
            <p className="ma0 mt3 mt4-l">
              <Link
                to={{
                  pathname: '/guides/edit/new',
                  state: { guide: newGuide(context.profile), mode: 'new' },
                }}
                className="f5 link dim br-pill bg-black-10 hover-bg-black-20 ph4 pv3 mh1 dib bw0 pointer black b"
              >
                Get Started
              </Link>
            </p>
          </PromoCard>
          <Card>&nbsp;</Card>
          <Card>&nbsp;</Card>
        </React.Fragment>
      )}
      {state.data.map((guide: Guide) => (
        <GuideCard
          guide={guide}
          stats={getStatsForGuide(statsState.data, guide.id)}
        />
      ))}
      {props.children}
    </CardList>
  );
};
